import React, { useContext } from 'react';
import DatePicker from 'react-datepicker';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';

import { AccordionItem } from 'formlabs-web-components/Media';
import { Input } from 'formlabs-web-components/Form';

import LocaleContext from '../../context/locale';

import './DateFilter.module.css';

const DateFilter = ({ start, end, updateFilter, label }) => {
  const { t } = useTranslation();
  const { dateLocale } = useContext(LocaleContext);

  const updateDate = (which, date) => {
    const dateObj = new Date(date);
    const formattedDate = format(dateObj, 'yyyy-MM-dd');
    updateFilter(which, formattedDate);
  };

  const startDateSplit = start !== null ? start.split('-') : start;
  const endDateSplit = end !== null ? end.split('-') : end;

  const startDate =
    startDateSplit !== null
      ? new Date(startDateSplit[0], startDateSplit[1] - 1, startDateSplit[2])
      : startDateSplit;
  const endDate =
    endDateSplit !== null
      ? new Date(endDateSplit[0], endDateSplit[1] - 1, endDateSplit[2])
      : endDateSplit;

  return (
    <AccordionItem open title={label}>
      <div styleName="picker">
        <DatePicker
          placeholderText={t('Start Date')}
          selected={startDate}
          onChange={date => updateDate('start', date)}
          selectsStart
          startDate={startDate}
          endDate={endDate}
          maxDate={endDate}
          dateFormat="P"
          customInput={<Input />}
          locale={dateLocale}
        />
      </div>
      <div styleName="picker">
        <DatePicker
          placeholderText={t('End Date')}
          selected={endDate}
          onChange={date => updateDate('end', date)}
          selectsEnd
          startDate={startDate}
          endDate={endDate}
          minDate={startDate}
          dateFormat="P"
          customInput={<Input />}
          locale={dateLocale}
        />
      </div>
    </AccordionItem>
  );
};

export default DateFilter;
